import { Navigate } from "react-router-dom";

/**
 * RequireAdmin
 * Uses sessionStorage so login expires when the browser tab/window is closed.
 *
 * Props:
 *   masterOnly={true}       → only MASTER_ADMIN
 *   dashboardAdminOk={true} → MASTER_ADMIN + DASHBOARD_ADMIN (for OPD viewer)
 *   (default)               → any logged-in admin
 */
export default function RequireAdmin({ children, masterOnly = false, dashboardAdminOk = false }) {
  const token = sessionStorage.getItem("adminToken");
  if (!token) return <Navigate to="/clinic-management/signin" replace />;

  try {
    const user = JSON.parse(sessionStorage.getItem("adminUser") || "{}");

    if (masterOnly) {
      if (user.role !== "MASTER_ADMIN") return <Navigate to="/admin" replace />;
    }

    if (dashboardAdminOk) {
      const allowed = ["MASTER_ADMIN", "DASHBOARD_ADMIN"];
      if (!allowed.includes(user.role)) return <Navigate to="/admin" replace />;
    }
  } catch {
    return <Navigate to="/clinic-management/signin" replace />;
  }

  return children;
}